/**
 * useDebouncedValue — devuelve `value` retrasado `delayMs`. Útil para
 * inputs de búsqueda que persisten en URL search params: el usuario
 * teclea sin generar una entrada de historial por carácter, y el push
 * a la URL se hace tras el último cambio dentro de la ventana de delay.
 *
 * Implementación mínima — sin deps externas. Lifecycle:
 *  - Cada cambio de `value` resetea el timeout.
 *  - El cleanup del effect evita actualizaciones tras unmount.
 */

import { useEffect, useState } from 'react'

export function useDebouncedValue<T>(value: T, delayMs: number = 300): T {
  const [debounced, setDebounced] = useState<T>(value)
  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(handle)
  }, [value, delayMs])
  return debounced
}
